// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Z81","footer":"styles_footer__38Gna"};